import { Controller } from "@hotwired/stimulus"

// Shows the custom path field only while "Custom path…" is picked in the
// announcement's deep link select, and requires it while shown. The server
// ignores the field otherwise.
export default class extends Controller {
  static targets = ["select", "custom"]

  connect() {
    this.sync()
  }

  // On change: show or hide the field, and focus it when it appears.
  toggle() {
    if (this.sync()) this.input?.focus({ preventScroll: true })
  }

  sync() {
    const custom = this.selectTarget.value === "custom"
    this.customTarget.classList.toggle("d-none", !custom)
    if (this.input) this.input.required = custom
    return custom
  }

  get input() {
    return this.customTarget.querySelector("input")
  }
}
